import domReady from '@wordpress/dom-ready';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import { tablet } from './../settings';
import { gsapAppearTitle } from './../utils';
gsap.registerPlugin(ScrollTrigger);

domReady(() => {
	const ctas = document.querySelectorAll('.ctas');
	if (ctas && ctas.length) {
		let mm = gsap.matchMedia();
		ctas.forEach((block) => {
			const ctasTitle = block.querySelector('.ctas-title');
			const ctasDescription = block.querySelector('.ctas-description');
			const ctasButtons = block.querySelectorAll(
				'.ctas-buttons .wp-block-button'
			);

			mm.add(`(min-width: ${tablet}px)`, () => {
				let timeline = gsap.timeline({
					scrollTrigger: {
						trigger: block,
						toggleActions: 'play pause pause pause',
						start: 'top 70%',
						end: 'center top',
					},
				});

				timeline = gsapAppearTitle(timeline, ctasTitle);

				timeline
					.from(
						ctasDescription,
						{
							opacity: 0,
							duration: 0.4,
						},
						'<0.3'
					)
					.from(
						ctasButtons,
						{
							scale: 0,
							stagger: 0.05,
							duration: 0.2,
							ease: 'back',
						},
						'<+0.2'
					);
			});
		});
	}
});
